export default "__VITE_ASSET__Ck6xioao__"